import React from 'react'
import '../base/Theme.css';
import './Terms.css';
import Text from "../base/text/Text";
import Toolbar from "../base/toolbar/Toolbar";
import Back from "../base/back/Back";
import Space from "../base/space/Space";

function Terms() {

    return (
        <div className="Root">
            <div className="Content">
                <Toolbar title={"Terms & Conditions"} leftButton={<Back/>}/>
                <Text style="TermsText"
                      text={"These are the Terms and Conditions governing the use of this Service and the agreement that operates between You and the Developers. "}/>
                <Space space={16}/>
                <Text style="TermsText"
                      text={"These Terms and Conditions apply to all visitors, users and others who access or use the Service. " +
                      "By accessing or using the Service You agree to be bound by these Terms and Conditions. " +
                      "If You disagree with any part of these Terms and Conditions then You may not access the Service. "}/>
                <Space space={16}/>
                <Text style="TermsText"
                      text={"You represent that you are over the age of 18. If you are under 18, You should not use this Service."}/>
                <Space space={16}/>
                <Text style="TermsText"
                      text={"Developers are not responsible for any losses caused by using this Service and are not obligated to compensate Users. " +
                      "The cause of losses includes but is not limited to faulty code, hacked website, terminated account."}/>
                <Space space={16}/>
                <Text style="TermsText"
                      text={"Your access can be terminated immediately, without prior notice or liability, for any reason whatsoever, including without limitation if You breach these Terms and Conditions. " +
                      "Upon termination, Your right to use the Service will cease immediately."}/>
                <Space space={16}/>
                <Text style="TermsText"
                      text={"These Terms can be modified or replaced at any time. " +
                      "By continuing to access or use Service after those changes, You agree to be bound by the new terms. " +
                      "If You do not agree to the new terms, in whole or in part, please stop using the website and the Service."}/>
            </div>
        </div>
    );
}

export default Terms;
